import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { getCaseCategoryByCaseType } from "../../../../utils";
import { Label, Toaster } from "@fluentui/react-components";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getPolicyDetailById,
  getPolicyPaymentDetailById,
  getPolicyPaymentsCommissionDetailById,
  getPolicyPaymentsCommissionsListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function PolicyPaymentCommissions({ tab }: { tab?: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, action, caseId, subItemId, subSubItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const policies = useSelector((state: RootState) => state.policies);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [caseType, setCaseType] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>(tab || "commission");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId && subItemId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
      dispatch(getPolicyPaymentDetailById(subItemId));
      dispatch(
        getPolicyPaymentsCommissionsListItems({
          paymentId: subItemId,
          caseId,
          customerId: clientId,
        })
      );
    }
  }, [caseId, clientId, subItemId, dispatch]);

  useEffect(() => {
    if (policies?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(policies.activeItem.case_type));
    }
  }, [policies.activeItem]);

  useEffect(() => {
    if (subItemId && policies.payments.listItems.length > 0) {
      dispatch(getPolicyPaymentDetailById(subItemId));
    }
  }, [subItemId, activeTab, policies.payments.listItems, dispatch]);

  useEffect(() => {
    if (subSubItemId && policies?.payments?.commissions?.listItems.length > 0) {
      dispatch(getPolicyPaymentsCommissionDetailById(subSubItemId));
    }
  }, [
    subSubItemId,
    activeTab,
    policies.payments.commissions.listItems,
    dispatch,
  ]);

  const paymentId =
    subItemId || policies?.payments?.listItems?.[0]?.payment?.payment_id;
  const commissionId =
    subSubItemId || policies.payments?.commissions?.listItems[0]?.commission_id;

  useEffect(() => {
    if (!caseId || !paymentId || !commissionId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`
      );
    } else if (action === "add") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/add`
      );
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/policies/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`
      );
    }
  }, [
    action,
    clientId,
    tab,
    caseId,
    paymentId,
    commissionId,
    policies.payments.commissions.listItems,
    navigate,
  ]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="policies"
        tab={activeTab}
        caseType={caseType}
        caseDetail={policies.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="policies"
          caseType={caseType}
          caseDetail={policies.payments.commissions.activeItem}
          caseItemList={policies.payments.commissions.listItems}
          tab={activeTab}
          subItem="payments"
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />

        <div>
          {policies?.payments.commissions.loading ? (
            <ContentLoader />
          ) : (
            <>
              {policies?.payments.commissions.listItems.length > 0 && (
                <CaseList
                  module="commission"
                  data={policies?.payments.commissions.listItems}
                  activeItem={policies?.payments.commissions.activeItem}
                  section="policies"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action &&
                policies?.payments.commissions.listItems.length === 0 && (
                  <NoDataFound />
                )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={policies?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default PolicyPaymentCommissions;
